import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import importFilesService from "../../services/importFiles.service";
import * as Util from "../../services/global.service";
import { useFormik } from 'formik';
import { find } from 'lodash';
import * as yup from 'yup';

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { icon, btn, color, open, close, data, description, name, typeFiles } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [dataTemplateType, setDataTemplateType] = React.useState([]);
  const [dataCycle, setDataCycle] = React.useState([]);
  const [require, setRequire] = React.useState(false);
  const [dataTemplate, setDataTemplate] = React.useState([]);
  const [currentTemplateType, setCurrentTemplateType] = React.useState(null)

  const handleCloseDialog = () => {
    close(false);
  };
  const validationSchema = yup.object({
    templateType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    fileType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
  });
  const formik = useFormik({
    initialValues: {
      templateType: "",
      cycle: "",
      fileType: "xlsx",
      templateID: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
    },
  });

  useEffect(() => {
    if (open) {
      importFilesService.getTemplateType().then((rs) => {
        setDataTemplateType(Util.formatData(rs?.data?.templates, []));
        setDataCycle(Util.formatData(rs?.data?.cycles, []));
      }).catch((err) => {

      })
    }
    formik.setFieldValue("templateType", "")
    formik.setFieldValue("cycle", "")
    formik.setFieldValue("templateID", "")
    formik.setFieldValue("fileType", "xlsx")
    setDataTemplate([])
  }, [open]);

  useEffect(() => {
    formik.setFieldValue("templateID", "")
  }, [dataTemplate])

  let setValFilter = (field, data) => {
    formik.setFieldValue(field, data)
    switch (field) {
      case 'templateType':
        let require_cycle = false
        let curentItem = find(dataTemplateType, { id: data })
        if (curentItem) {
          require_cycle = curentItem.require_cycle
        }
        setRequire(require_cycle)
        setCurrentTemplateType(curentItem)

        break;

      case 'cycle':
        let templates = []
        let cycle = find(dataCycle, { id: data })
        if (cycle) {
          templates = cycle.templates || []

          console.log('currentTemplateType', currentTemplateType)

          if (currentTemplateType && currentTemplateType?.code === 'competency_mapping') templates = []
        }
        setDataTemplate(templates)
        break;

      default:
        break;
    }


    /*
    if (require_cycle !== "") {
      if (field === "templateType") {
        formik.setFieldValue("templateType", data)
        setRequire(require_cycle)
        if (require_cycle === false) {
          formik.setFieldValue("cycle", "")
          setDataTemplate([])
        }
      } else {
        formik.setFieldValue(field, data)

        if (field === "cycle") {
          let cycle = find(dataCycle, { id: data })
          if (cycle) {
            console.log('formik.values.templateType', formik.values.templateType)
            setDataTemplate(cycle.templates || [])
          }
          else setDataTemplate([])
        }
      }
    } else {
      formik.setFieldValue(field, data)
    }
    */
  }
  let downloadTemplate = () => {
    importFilesService.downloadTemplate({
      "template": formik.values.templateType,
      "cycle": formik.values.cycle,
      "file_type": formik.values.fileType,
      "template_id": formik.values.templateID,
    }).then((rs) => {
      window.location = rs.data.file
      handleCloseDialog()
    }).catch((err) => {

    })
  }


  useEffect(() => {
    if (!require) setDataTemplate([])
  }, [require])


  useEffect(() => {
    if (currentTemplateType && currentTemplateType?.code === 'competency_mapping') setDataTemplate([])
  }, [currentTemplateType])

  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }} color="#404349">
        Download Template
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0" }}>
        <Box sx={{ padding: "10px 0" }}>
          <Typography fontSize={14} lineHeight="20.93px" color="#A0A0A0">
            After download template, please make sure you fill in the data in the template (at least required field).
          </Typography>
        </Box>
        <Box>
          <Box pt="5px" pb="20px" sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Template Type <span style={{ color: "#CC6058" }}>*</span></Typography>
            <Select
              variant="outlined"
              defaultValue=""
              displayEmpty
              size="small"
              fullWidth
              className="white-bg"
              value={formik.values.templateType}
              classes={{ root: classes.select }}
              MenuProps={{ autoFocus: false }}
              inputProps={{
                sx: {
                  "&::placeholder": {
                    color: "#AAAAAA",
                    fontWeight: "300",
                    opacity: "1"
                  }
                }
              }}
            >
              <MenuItem disabled value="" sx={{ display: "none" }}>
                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select template type</Typography>
              </MenuItem>
              {Util.formatData(dataTemplateType, []).length > 0 ?
                dataTemplateType.map((item, idx) => {
                  return (
                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("templateType", item?.id)}>
                      <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                    </MenuItem>
                  )
                })
                :
                <MenuItem value="">
                  <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                </MenuItem>
              }
            </Select>
          </Box>
          <Box pb="20px" sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Export file type <span style={{ color: "#CC6058" }}>*</span></Typography>
            <Select
              variant="outlined"
              defaultValue=""
              displayEmpty
              size="small"
              fullWidth
              className="white-bg"
              value={formik.values.fileType}
              classes={{ root: classes.select }}
              MenuProps={{ autoFocus: false }}
              inputProps={{
                sx: {
                  "&::placeholder": {
                    color: "#AAAAAA",
                    fontWeight: "300",
                    opacity: "1"
                  }
                }
              }}
            >
              <MenuItem disabled value="" sx={{ display: "none" }}>
                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select export file type</Typography>
              </MenuItem>
              {Util.formatData(typeFiles, []).length > 0 ?
                typeFiles.map((item, idx) => {
                  return (
                    <MenuItem value={item} key={item} onClick={e => setValFilter("fileType", item)}>
                      <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item}</span>
                    </MenuItem>
                  )
                })
                :
                <MenuItem value="">
                  <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                </MenuItem>
              }
            </Select>
          </Box>
          <Box pb="20px" sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Cycle <span style={{ color: "#CC6058" }}>*</span></Typography>
            <Select
              variant="outlined"
              defaultValue=""
              displayEmpty
              size="small"
              fullWidth
              className="white-bg"
              value={formik.values.cycle}
              disabled={!require}
              classes={{ root: require ? classes.select : classes.selectDisabled }}
              MenuProps={{ autoFocus: false }}
              inputProps={{
                sx: {
                  "&::placeholder": {
                    color: "#AAAAAA",
                    fontWeight: "300",
                    opacity: "1"
                  }
                }
              }}
            >
              <MenuItem disabled value="" sx={{ display: "none" }}>
                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select cycle</Typography>
              </MenuItem>
              {Util.formatData(dataCycle, []).length > 0 ?
                dataCycle.map((item, idx) => {
                  return (
                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("cycle", item.id)}>
                      <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                    </MenuItem>
                  )
                })
                :
                <MenuItem value="">
                  <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                </MenuItem>
              }
            </Select>
          </Box>
          <Box pb="20px" sx={{ width: "100%", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" } }}>
            <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.label.evaluationJourney')}</Typography>
            <Select
              variant="outlined"
              defaultValue=""
              displayEmpty
              size="small"
              fullWidth
              className="white-bg"
              value={formik.values.templateID}
              disabled={!require || dataTemplate.length === 0}
              classes={{ root: (require && dataTemplate.length > 0) ? classes.select : classes.selectDisabled }}
              MenuProps={{ autoFocus: false }}
              inputProps={{
                sx: {
                  "&::placeholder": {
                    color: "#AAAAAA",
                    fontWeight: "300",
                    opacity: "1"
                  }
                }
              }}
            >
              <MenuItem value="" onClick={e => setValFilter("templateID", "")}>
                <Typography variant="sub_label" style={{ color: "#404349", fontSize: "16px", fontWeight: "300", lineHeight: "23.92px" }}>{t('label.selectAll')}</Typography>
              </MenuItem>
              {Util.formatData(dataTemplate, []).length > 0 ?
                dataTemplate.map((item, idx) => {
                  return (
                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("templateID", item.id)}>
                      <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                    </MenuItem>
                  )
                })
                :
                <MenuItem value="">
                  <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                </MenuItem>
              }
            </Select>
          </Box>
          <Box sx={{ justifyContent: "center", display: "flex", paddingTop: "10px" }}>
            <Box sx={{ display: "flex", width: "211px", justifyContent: "center" }}>
              <Button color="primary" variant="contained" fullWidth disabled={formik.values.templateType !== "" && require ? formik.values.cycle !== "" ? false : true : formik.values.templateType !== "" && require === false ? false : true} onClick={downloadTemplate}>
                <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="29px" fontWeight="500" color="#FFF">Download</Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
